/** The Passport boards' line icons (the alignment map's ui-* sprite), drawn inline. */
import type { ReactNode } from 'react'

const PATHS = {
  pouch: (
    <>
      <path d="M7 3h10l1 4v12a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7z" />
      <path d="M6 7h12" />
      <path d="M9.5 12h5M9.5 15h5" />
    </>
  ),
  ok: <path d="M5 12.5l4.5 4.5L19 7.5" />,
  flask: (
    <>
      <path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 1.7 3h10.6A2 2 0 0 0 19 18l-5-9V3" />
      <path d="M7.5 15h9" />
    </>
  ),
  list: (
    <>
      <path d="M9 6h11M9 12h11M9 18h11" />
      <circle cx="4.5" cy="6" r="1" />
      <circle cx="4.5" cy="12" r="1" />
      <circle cx="4.5" cy="18" r="1" />
    </>
  ),
  file: (
    <>
      <path d="M6 3h9l4 4v14H6z" />
      <path d="M14 3v5h5" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s-6.5-6.2-6.5-11a6.5 6.5 0 0 1 13 0c0 4.8-6.5 11-6.5 11z" />
      <circle cx="12" cy="10" r="2.5" />
    </>
  ),
  field: (
    <>
      <path d="M3 21l4.5-8M9.3 21l1.8-8M14.7 21l-1.8-8M21 21l-4.5-8M2.5 13h19" />
      <path d="M12 13V7M12 9c1.5-2.2 3-2.8 4.2-2.8-.3 1.6-1.7 2.8-4.2 2.8zM12 10c-1.5-2.2-3-2.8-4.2-2.8.3 1.6 1.7 2.8 4.2 2.8z" />
    </>
  ),
  machine: (
    <>
      <rect x="4" y="9" width="16" height="9" rx="1.5" />
      <path d="M8 9l2-5h4l2 5" />
      <circle cx="12" cy="13.5" r="2.5" />
      <path d="M6 18v2M18 18v2" />
    </>
  ),
  call: (
    <path d="M5 4h3.5l1.8 4.5-2.3 1.4a11 11 0 0 0 6.1 6.1l1.4-2.3L20 15.5V19a1.5 1.5 0 0 1-1.6 1.5A16 16 0 0 1 3.5 5.6 1.5 1.5 0 0 1 5 4z" />
  ),
  phone: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="2" />
      <path d="M11 18h2" />
    </>
  ),
  hourglass: (
    <>
      <path d="M7 3h10M7 21h10" />
      <path d="M8 3c0 4.5 4 5.5 4 9s-4 4.5-4 9" />
      <path d="M16 3c0 4.5-4 5.5-4 9s4 4.5 4 9" />
    </>
  ),
  recall: (
    <>
      <path d="M4 12a8 8 0 1 0 3-6.2" />
      <path d="M4 4v4h4" />
      <path d="M12 8v4l3 2" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16 16l4.5 4.5" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  x: <path d="M6 6l12 12M18 6L6 18" />,
  down: <path d="M6 9l6 6 6-6" />,
} satisfies Record<string, ReactNode>

export type PassportIconName = keyof typeof PATHS

export function PIcon({ name, size = 20, stroke = 2 }: { name: PassportIconName; size?: number; stroke?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {PATHS[name]}
    </svg>
  )
}
